import * as api from '../../api';
import { mutate } from 'swr';
import localforage from 'localforage';

const formatDate = date => {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
};

export const loadReports = async (type, dateRange, groupBy, search = '') => {
    const query = {
        type,
        start_date: formatDate(dateRange.from),
        end_date: formatDate(dateRange.to),
        search,
    };
    switch (groupBy) {
        case 'website':
            query.group_by_website = true;
            break;
        case 'user':
            query.group_by_user = true;
            break;
        default:
            break;
    }

    const getData = page => {
        const params = new URLSearchParams({ ...query, page });
        const url = `/api/partner/reports?${params.toString()}`;
        return api.checkResponse(api.get(url), true);
    };

    try {
        const { data: reports, total_pages: total } = await getData(1);
        if (total > 1) {
            const BATCH_SIZE = 5;
            for (let i = 2; i <= total; i += BATCH_SIZE) {
                const batch = [];
                for (let j = i; j <= Math.min(i + BATCH_SIZE - 1, total); j++) {
                    batch.push(getData(j));
                }
                const results = await Promise.all(batch);
                results.forEach(({ data }) => reports.push(...data));
            }
        }
        return reports;
    } catch (error) {
        console.error('Error loading reports:', error);
        throw error;
    }
};

export const invalidateReportsCache = async (currentUserUuid, reportType) => {
    const cacheKey = `${currentUserUuid}-/api/partner/reports-${reportType}`;

    await mutate(cacheKey, undefined, false);

    await localforage.removeItem(cacheKey);
};

export const refreshReportsCache = async (currentUserUuid, reportType) => {
    const cacheKey = `${currentUserUuid}-/api/partner/reports-${reportType}`;
    await mutate(cacheKey);
};
